import type {
  InboundShipment,
  InboundListResponse,
  CreateInboundRequest,
  UpdateIQCRequest,
  CompleteIQCRequest,
  InboundFilter,
  InboundStatus,
} from '../types/inbound';
import { get, post, patch, del, buildUrl } from './apiClient';

const API_BASE = '/api/v1/inbound';

// ============================================================================
// Inbound Shipment CRUD
// ============================================================================

export async function createInboundShipment(request: CreateInboundRequest): Promise<InboundShipment> {
  return post<InboundShipment>(API_BASE, request);
}

export async function getInboundShipment(id: string): Promise<InboundShipment> {
  return get<InboundShipment>(`${API_BASE}/${id}`);
}

export async function listInboundShipments(filter?: InboundFilter): Promise<InboundListResponse> {
  return get<InboundListResponse>(buildUrl(API_BASE, filter));
}

export async function deleteInboundShipment(id: string): Promise<void> {
  await del(`${API_BASE}/${id}`);
}

// ============================================================================
// IQC Management
// ============================================================================

export async function updateItemIQC(inboundId: string, request: UpdateIQCRequest): Promise<void> {
  await patch(`${API_BASE}/${inboundId}/items/${request.line_no}/iqc`, request);
}

export async function completeIQC(inboundId: string, request: CompleteIQCRequest): Promise<void> {
  await post(`${API_BASE}/${inboundId}/complete-iqc`, request);
}

// ============================================================================
// Status Management
// ============================================================================

export async function updateInboundStatus(id: string, status: InboundStatus): Promise<void> {
  await patch(`${API_BASE}/${id}/status`, { status });
}

// Complete the inbound shipment and update inventory
export async function completeInbound(id: string): Promise<void> {
  await post(`${API_BASE}/${id}/complete`);
}
